import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {GetUserAlertsMatchesTrackingError} from '../Errors/GetUserAlertsMatchesTrackingError.js'
import {UserAlertsMatchesPageTrackingMapper} from '../Mappers/UserAlertsMatchesPageTrackingMapper.js'

class GetUserAlertsMatchesTrackingUseCase extends UseCase {
  #mapper

  #handleError(error) {
    if (GetUserAlertsMatchesTrackingError.isGetUserAlertsMatchesTrackingError({error})) return Promise.reject(error)
    return Promise.reject(GetUserAlertsMatchesTrackingError.createGenericError({cause: error}))
  }

  constructor({mapper}) {
    super()
    this.#mapper = mapper
  }

  static create({config}) {
    return new GetUserAlertsMatchesTrackingUseCase({mapper: UserAlertsMatchesPageTrackingMapper.create({config})})
  }

  @tracer({metric: 'GetUserAlertsMatchesTrackingUseCase#execute'})
  @AsyncInlineError()
  async execute({filters} = {}) {
    try {
      return this.#mapper.map({filters})
    } catch (error) {
      return this.#handleError(error)
    }
  }
}

export const factory = GetUserAlertsMatchesTrackingUseCase.create
